<template>
  <Form
    :title="title"
    :description="description"
    :handlePrevious="decrementIndex"
    :handleNext="incrementIndex"
    :isDisabled="!job || !element"
  >
    <InputField
      label="NickName"
      placeholder="Cliff"
      :value="nickName"
      @input="$event => setNickName($event.target.value)"
    />
    <SelectField
      label="Job"
      :options="['Bowman', 'Knight', 'Paladin', 'Wizard']"
      :value="job"
      isRequired
      @input="$event => setJob($event.target.value)"
    />
    <SelectField
      label="Element"
      :options="['Fire', 'Rock', 'Earth', 'Wind', 'Water', 'Ice', 'Lightning']"
      :value="element"
      isRequired
      @input="$event => setElement($event.target.value)"
    />
  </Form>
</template>

<script>
import Form from '@/components/Form';
import InputField from '@/components/InputField';
import SelectField from '@/components/SelectField';
import useIndex from '@/composition/useIndex';
import useField from '@/composition/useField';

export default {
  name: 'Fantasy',
  components: {
    Form,
    InputField,
    SelectField
  },
  props: {
    title: String,
    description: String
  },
  setup() {
    const { incrementIndex, decrementIndex } = useIndex();
    const [nickName, setNickName] = useField('nickName');
    const [job, setJob] = useField('job');
    const [element, setElement] = useField('element');

    return {
      incrementIndex,
      decrementIndex,
      nickName,
      setNickName,
      job,
      setJob,
      element,
      setElement
    };
  }
};
</script>
